<template>
<b-container
  class="bg-light p-3 p-lg-5"
  fluid
  >
  <b-row>
    <b-col
      class="text-center p-lg-5"
      xl="8"
      offset-xl="2"
      >
      <div class="py-5 p-lg-5">
	<h2 class="mb-3">
	  <slot name="subtitle">"Folders are so 2019"</slot>
	</h2>
	<h1>
	  <slot name="title">TrinApp<sup>&trade;</sup> Files thinks like humans do!</slot>
	</h1>
      </div>
    </b-col>
  </b-row>
  <b-row>
    <b-col
      cols="12"
      lg="7"
      offset-lg="1"
      xl="4"
      offset-xl="3"
      class="px-4 order-2 order-lg-1"
      >      
      <div class="d-flex">
	<font-awesome-icon
	  :icon="faCheck"
	  class="mr-3 mt-1 mb-auto"
	  :style="{ color : checkColor }"
	  />
	<p class="mb-1">
	  <slot name="bullet-1">TrinApp<sup>&trade;</sup> Files conceptually links your data silos into your One-World model</slot>
	</p>
      </div>
      <div class="d-flex">
	<font-awesome-icon
	  :icon="faCheck"
	  class="mr-3 mt-1 mb-auto"
	  :style="{ color : checkColor }"
	  />
	<p class="mb-1">
	  <slot name="bullet-2">TrinApp<sup>&trade;</sup> Files does NOT store files, drawings and specs in Folders!</slot>
	</p>
      </div>
      <div class="d-flex">
	<font-awesome-icon
	  :icon="faCheck"
	  class="mr-3 mt-1 mb-auto"
	  :style="{ color : checkColor }"
	  />
	<p class="mb-1">
	  <slot name="bullet-3">Manual Tagging is optional, Trinity automatically creates links for you.</slot>
	</p>
      </div>
      <div class="d-flex">
	<font-awesome-icon
	  :icon="faCheck"
	  class="mr-3 mt-1 mb-auto"
	  :style="{ color : checkColor }"
	  />
	<p class="mb-1">
	  <slot name="bullet-4">Finding files is impressively fast, with no need to remember folders or specific keywords.</slot>
	</p>
      </div>
      <div class="d-flex">
	<font-awesome-icon
	  :icon="faCheck"
	  class="mr-3 mt-1 mb-auto"
	  :style="{ color : checkColor }"
	  />
	<p class="mb-1">
	   <slot name="bullet-5">Files can be placed in multiple projects, sub-projects and containers, wherever you like, without duplicating it, or later having two or more different copies of the same file.</slot>
	</p>
      </div>
      <div class="d-flex">
	<font-awesome-icon
	  :icon="faCheck"
	  class="mr-3 mt-1 mb-auto"
	  :style="{ color : checkColor }" />
	<p class="mb-1">
	  <slot name="bullet-6">Ideas and information in data and files change over time, so Trinity tracks every change to your information.*</slot>
	</p>
      </div>
      <sub style="font-style: italic;">* available when used together with TrinPods</sub>
    </b-col>
    <b-col
      cols="12"
      lg="3"
      xl="2"
      class="text-center order-1 order-lg-2"
      >
      <slot name="icon">
	<b-img
	  :src="require('../assets/trinity_cool_anim.gif')"
	  class="pb-5"
	  />
      </slot>
    </b-col>
  </b-row>
  <b-row>
    <b-col class="text-center py-5">
      <slot name="button">
	<b-button
	  size="lg"
	  class="btn btn-neon-blue"
	  href="https://trinpod.us/pricing?industry=productivity"
	  >
	  Get Started
	</b-button>
      </slot>
    </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
export default {
    name: "Layout04",
    components: {
	FontAwesomeIcon
    },
    data () {
	return {
            faCheck
        }
    },
    props: {
	checkColor: String
    }
}
</script>
